import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ChaveValor } from '@app/shared/models/chave-valor.model';

@Injectable()
export class EscolaridadeService {

  constructor(public http: HttpClient) { }

  getEscolaridade(): Observable<ChaveValor[]> {
    return this.http.get<ChaveValor[]>('assets/server/escolaridade.json');
  }

}
